module.exports = __webpack_public_path__ + "static/media/LTU.bf4d4b72.svg";